export const  API_KEY =  "AIzaSyA0v1nG-xQrSJp-U64Uz5fsRZ33Y619GQM" 

export default API_KEY